/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BoardReportSummaryDto
 */
export interface BoardReportSummaryDto {
    /**
     * 
     * @type {string}
     * @memberof BoardReportSummaryDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof BoardReportSummaryDto
     */
    profileId?: string;
    /**
     * 
     * @type {Date}
     * @memberof BoardReportSummaryDto
     */
    generatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof BoardReportSummaryDto
     */
    generatedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof BoardReportSummaryDto
     */
    reportPeriod?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BoardReportSummaryDto
     */
    firstReport?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof BoardReportSummaryDto
     */
    humanReviewedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof BoardReportSummaryDto
     */
    humanReviewedBy?: string;
}

/**
 * Check if a given object implements the BoardReportSummaryDto interface.
 */
export function instanceOfBoardReportSummaryDto(value: object): value is BoardReportSummaryDto {
    return true;
}

export function BoardReportSummaryDtoFromJSON(json: any): BoardReportSummaryDto {
    return BoardReportSummaryDtoFromJSONTyped(json, false);
}

export function BoardReportSummaryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BoardReportSummaryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'profileId': json['profileId'] == null ? undefined : json['profileId'],
        'generatedAt': json['generatedAt'] == null ? undefined : (new Date(json['generatedAt'])),
        'generatedBy': json['generatedBy'] == null ? undefined : json['generatedBy'],
        'reportPeriod': json['reportPeriod'] == null ? undefined : json['reportPeriod'],
        'firstReport': json['firstReport'] == null ? undefined : json['firstReport'],
        'humanReviewedAt': json['humanReviewedAt'] == null ? undefined : (new Date(json['humanReviewedAt'])),
        'humanReviewedBy': json['humanReviewedBy'] == null ? undefined : json['humanReviewedBy'],
    };
}

export function BoardReportSummaryDtoToJSON(json: any): BoardReportSummaryDto {
    return BoardReportSummaryDtoToJSONTyped(json, false);
}

export function BoardReportSummaryDtoToJSONTyped(value?: BoardReportSummaryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'profileId': value['profileId'],
        'generatedAt': value['generatedAt'] == null ? undefined : ((value['generatedAt']).toISOString()),
        'generatedBy': value['generatedBy'],
        'reportPeriod': value['reportPeriod'],
        'firstReport': value['firstReport'],
        'humanReviewedAt': value['humanReviewedAt'] == null ? undefined : ((value['humanReviewedAt']).toISOString()),
        'humanReviewedBy': value['humanReviewedBy'],
    };
}

